import { motion } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
const motionTheme = themed({
  "lodestar-light": "",
  "ursa-light": `all ${motion.animation.default}`
});
export const getButtonMotion = _ref => {
  let {
    themeMode
  } = _ref;
  return motionTheme(themeMode);
};
//# sourceMappingURL=getButtonMotion.js.map